<template>
	<AppButton
		startIcon="assets/v2/image/icons/plus.svg"
		:label="buttonLabel"
		@click="onLinkMarketplace"
		:disabled="authStore.isAgentSubscriptionExpired"
	/>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useCreateMarketplaceDialogStore } from '../../../stores/create-marketplace-dialog';
import { abilities, useLimitationsStore } from '@/v2/modules/products/stores/limitations';
import { featureFlag, isFeatureFlagEnabled } from '@/v2/entities/feature-flag';
import { useAuthStore } from '@/v2/store/shared/auth-store';

const { t } = useI18n();
const createMarketplaceDialogStore = useCreateMarketplaceDialogStore();
const limitationsStore = useLimitationsStore();
const authStore = useAuthStore();

const buttonLabel = computed(() => {
	return isFeatureFlagEnabled(featureFlag.E_COMMERCE)
		? t('integrations.link-a-new-marketplace')
		: t('integrations.link-a-communication-channel');
});

const onLinkMarketplace = () => {
	limitationsStore.checkLimitation(abilities.LinkNewMarketplace).then(() => {
		createMarketplaceDialogStore.openDialog();
	});
};
</script>

<style lang="scss" scoped></style>
